import React from 'react';
import { PropTypes } from 'prop-types';
import PageSectionTitle from '../../../../components/PageSectionTitle';
import './CreatorMastercourseSection.scss';
import Image from '../../../../components/Image';
import StatCard from './partials/StatCard';
import CtaButton from './partials/CtaButton';
import Text from '../../../../components/Text';
import { starImageData } from '../../constants';
import { isDesktop } from '../../../../utility/domHelpers';

const CreatorMastercourseSection = ({
  title,
  coverImg,
  stats,
  vacancyCount,
  onCtaClick,
  avgRating,
  reviewCount,
  alumniCount,
}) => {
  const className = 'c-CreatorMastercourseSection';

  const ctaText = [
    {
      text: `${vacancyCount} SPOTS LEFT - `,
    },
    {
      text: 'JOIN NOW',
      isHighlighted: true,
    },
  ];

  const header = isDesktop
    ? 'PEOPLE LOVE NAS ACADEMY'
    : 'OVERALL COURSE RATING';

  return (
    <div className={className}>
      <div className={`${className}__info__wrapper`}>
        <div className={`${className}__info__wrapper--left`}>
          <Image {...coverImg} />
        </div>
        <div className={`${className}__info__wrapper--right`}>
          <PageSectionTitle title={title} />
          <div className={`${className}__info__stats`}>
            {stats.map((stat, index) => (
              <StatCard key={index} {...stat} />
            ))}
          </div>
          <CtaButton onClick={onCtaClick} btnText={ctaText} />
        </div>
      </div>
      <div className={`${className}__rating__wrapper`}>
        <div className={`${className}__rating__wrapper--left`}>
          <div className={`${className}__rating__wrapper--left__header`}>
            {header}
          </div>
        </div>
        <div className={`${className}__rating__wrapper--center`}>
          {!!avgRating && (
            <div className={`${className}__rating__container`}>
              <Image {...starImageData} />
              <Text text={avgRating} />
            </div>
          )}
          {!!reviewCount && (
            <div className={`${className}__review__container`}>
              <span className={`${className}__review-count`}>
                {reviewCount}+
              </span>{' '}
              reviews
            </div>
          )}
        </div>
        <div className={`${className}__rating__wrapper--right`}>
          <Text text="ALUMNI" />
          <div className={`${className}__alumni-count`}>{alumniCount}+</div>
        </div>
      </div>
    </div>
  );
};

CreatorMastercourseSection.defaultProps = {
  title: 'The Creator Mastercourse',
};

CreatorMastercourseSection.propTypes = {
  title: PropTypes.string.isRequired,
  coverImg: PropTypes.object.isRequired,
  stats: PropTypes.array.isRequired,
  vacancyCount: PropTypes.number,
  avgRating: PropTypes.number.isRequired,
  reviewCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  alumniCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default CreatorMastercourseSection;
